import springLogo from '../../src/images/icons8-spring-boot-48.png';
import neoLogo from '../../src/images/neo.png';
import canvaLogo from '../../src/images/canva.png';
import gitlab from '../../src/images/gitlab.png';
import rest from '../../src/images/rest.png';
import rabbit from '../../src/images/rabbit.png';
import cicd from '../../src/images/cicd3.png';
import mock from '../../src/images/mock.png';
import aws1 from '../../src/images/aws2.png';
import junit from '../../src/images/junit.png';
import uiux from '../../src/images/ux.png';
import pantech from '../../src/images/pantech.png';
import mnm from '../../src/images/mnm.png';
import agile from '../../src/images/agile2.png';
import intelli from '../../src/images/intelli.png';
import dav from '../../src/images/dav.png';
import gill from '../../src/images/gill.png';
import niit1 from '../../src/images/niit1.png';
import ethnus from '../../src/images/ethnus.png';
import hacker from '../../src/images/hacker2.png';
import kallada from '../../src/images/kallada1.png';
import udemy from '../../src/images/udemy.png';
import skill from '../../src/images/skillup1.png';
import greatlearning from '../../src/images/greatlearning.png';
import google from '../../src/images/google.png';
import excel from '../../src/images/excel.png';
import heroku from '../../src/images/heroku1.png';
import java from '../../src/images/java1.png';
import nodejs from '../../src/images/nodejs1.png';
import mongodb from '../../src/images/mongodb.png';
import github from '../../src/images/github.png';
import docker from '../../src/images/docker1.png';
import neo from '../../src/images/neo1.png';
import cloud from '../../src/images/cloudinary1.png';
import cursa from '../../src/images/cursa.png';
import aws3 from '../../src/images/aws4.png';
import railway from '../../src/images/railway.png';
import drim from '../../src/images/drim2.png';
import stack from '../../src/images/stack.png';
import vercel from '../../src/images/vercel2.png';
import neewee from '../../src/images/neewee.png';
import centscdn from '../../src/images/5centscdn_logo.jpeg';



export const Bio = {
  name: "Naveen Kumar",
  roles: [
    "Full Stack Development",
    "Backend Development",
    "Frontend Development",
    "Devops",
    "UI/UX Designing",
    "Product Management",
  
  ],
  description:
  "I’m a dedicated Software Engineer passionate about creating impactful solutions. As an aspiring Product Manager, I aim to bridge technology and strategy, ensuring innovation, precision, & delivering exceptional value to every project.",
    alllinks: "https://linktr.ee/naveenkumaran",
  github: "https://github.com/naveenkumarans",
  calender:"https://cal.com/naveenkumars",
  resume:
    "https://drive.google.com/file/d/1wHJoK8ce9k_nfh7lO4s6z2k6XX0berFz/view?usp=sharing"
    ,
  linkedin: "https://www.linkedin.com/in/naveenkumarans/",
  insta: "https://www.instagram.com/freakin__jerry/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "ReactJS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Angular",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg==",
      },
      {
        name: "Vue JS",
        image: "https://www.vectorlogo.zone/logos/vuejs/vuejs-icon.svg",
      },
    
     
   
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Angular Material",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg=="
          
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Elastic UI",
        image: "https://www.vectorlogo.zone/logos/elastic/elastic-icon.svg",
      },
      {
        name: "UI/UX",
        image: "https://img.icons8.com/external-sketchy-juicy-fish/60/external-experience-user-experience-sketchy-sketchy-juicy-fish-11.png",
      },
    
  
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node JS",
        image: "https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg",
      },
      {
        name: "SpringBoot",
        image:springLogo
          
      },
        {
        name: "Next JS",
        image: "https://img.icons8.com/fluency/240/nextjs.png",
      },
      
      {
        name: "Java",
        image:
          "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name:"Play",
        image:"https://upload.wikimedia.org/wikipedia/commons/5/5a/Play_Framework_logo.svg",
        
      },
      {
        name: "RestAPI",
        image: "https://img.icons8.com/color/48/api.png"
      },
      {
        name: "Maven",
        image: "https://user-images.githubusercontent.com/43886029/158700686-2b7f0d3d-2cfa-4ed0-9783-3b4b0d24469e.svg",
      },
      {
        name: "RabbitMQ",
        image: "https://www.vectorlogo.zone/logos/rabbitmq/rabbitmq-icon.svg",
      },
  
    ],
  },
  {
    title: "Database",
    skills: [
 
      {
        name: "MySQL",
        image:
          "https://www.mysql.com/common/logos/logo-mysql-170x115.png",
      },
      {
        name: "Postgresql",
        image: "https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Neo4J",
        image: "https://www.vectorlogo.zone/logos/neo4j/neo4j-icon.svg",
      },
      {
        name: "Cloudinary",
        image: cloud,
      },
     
    ],
  },
  {
    title: "Devops & Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.svg",
      },
      {
        name: "GitHub",
        image:
        "https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/24/external-github-community-for-software-building-and-testing-online-logo-shadow-tal-revivo.png",
      },
      {
        name: "Gitlab",
        image: "https://www.vectorlogo.zone/logos/gitlab/gitlab-icon.svg"
      },
      {
        name: "Docker",
        image:
          "https://www.vectorlogo.zone/logos/docker/docker-icon.svg",
      },
      {
        name: "Netlify",
        image:
       "https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/48/external-netlify-a-cloud-computing-company-that-offers-hosting-and-serverless-backend-services-for-static-websites-logo-shadow-tal-revivo.png",
      },
      {
        name: "Vercel",
        image:
        vercel,
      },
      
      {
        name: "Heroku",
        image:"https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg",
      },
      {
        name: "CI/CD",
        image: cicd,
      },
      {
        name: "MS Office",
        image: "https://upload.wikimedia.org/wikipedia/commons/0/0c/Microsoft_Office_logo_%282013%E2%80%932019%29.svg",
      },
      {
        name: "MS Excel",
        image: "https://img.icons8.com/fluency/240/microsoft-excel-2019.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "IntelliJ IDEA",
        image: "https://img.icons8.com/color/48/intellij-idea.png",
      },
      {
        name: "Agile",
        image: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/external-agile-project-management-flaticons-flat-flat-icons.png",
      },
      {
        name: "Google Analytics",
        image: "https://www.vectorlogo.zone/logos/google_analytics/google_analytics-icon.svg",
      },
      {
        name: "Postman",
        image:
          "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-postman-is-the-only-complete-api-development-environment-logo-color-tal-revivo.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c2/Adobe_XD_CC_icon.svg",
      },
      {
        name: "Figma",
        image:
          "https://img.icons8.com/color/48/figma--v1.png",
      },
      {
        name: "Canva",
        image: "https://www.vectorlogo.zone/logos/canva/canva-icon.svg"
      },
      {
        name: "AWS",
        image: "https://img.icons8.com/nolan/64/amazon-web-services.png",
      },
      {
        name: "Google Cloud",
        image: "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg",
      },
      
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
        
      {
        name: "Railway Cloud",
        image: railway,
      },
             
      {
        name: "Jenkins",
        image: "https://img.icons8.com/color/48/jenkins.png",
      },
    ],
  },
  {
    title: "Testing",
    skills: [
      {
        name: "Mockito",
        image: mock,
      },
     
      {
        name: "Junit 5",
        image: junit
      },
      {
        name: "Selenium",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Selenium_Logo.png",
      },
      {
        name: "Postman",
        image:
          "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-postman-is-the-only-complete-api-development-environment-logo-color-tal-revivo.png",
      },
    

  
    ],
  },
];

export const experiences = [

  {
    id: 6,
    img: centscdn,
    role: "Product Specialist - UI",
    company: "5 Cents CDN Inc",
    location:"Chennai, India",
    Type:"Full-Time",
    date: "September 2024 - Present",
    desc: "As a Product Specialist at 5cents CDN, I specialize in UI development and client management to deliver exceptional user experiences. "
        + "My achievements include enhancing interface design, which significantly boosted user satisfaction and led to a marked increase in positive feedback. "
        + "By optimizing front-end code and reducing page load times by 20%, I ensured a faster, more responsive platform accessible across all devices. "
        + "Additionally, my work on creating intuitive, visually engaging layouts has streamlined user interactions, aligning UI components with strategic objectives. "
        + "This has consistently exceeded client expectations, elevated overall platform performance, and contributed to the platform's success.",
    skills: [
      "UI Development",
      "HTML",
      "CSS",
      "JavaScript",
      "Angular",
      "Bootstrap",
      "Angular Material",
      "Figma",
      "Client Onboarding & Engagement",
      "Campaign Strategy",
      "CDN Technologies",
      "Product Consulting",
      "Cross-Functional Collaboration",
      "Technical Documentation",
      "Version Control (Git, GitHub)",
      "Market Research & Analysis",
      "Customer Success Management",
    ]    
  },
  {
    id: 5,
    img: neewee,
    role: "Software Engineer 1 - Full Stack",
    company: "Neewee Analytics",
    location:"Bengaluru, India",
    Type:"Full-Time",
    date: "December 2023 - September 2024",
    desc: "As a Software Engineer I at Neewee, I'm currently immersed in the Portescap project, showcasing my expertise in Angular, Java, and PostgreSQL. I actively contribute to both frontend and backend development, employing Git for version control and Jenkins for seamless integration. With a focus on efficiency, I optimize database interactions using PostgreSQL and implement DevOps practices, including tools like SwarmPit. My role at Neewee has not only honed my technical skills but also contributed significantly to my growth in the tech industry.",
    skills: [
      "Java",
      "HTML",
      "CSS",
      "JavaScript",
      "PostgreSQL",
      "Angular",
      "Bootstrap",
      "Jenkins",
      "MicroServices",
      "Git",
      "Github",
      "Swarmpit",
      "AWS",
      "CI/CD",
      "Docker",
      "RestApi",
      "Junit", 
      "Postman", 
    ]
    
    
  },

  {
    id: 4,
    img: stack,
    role: "Full Stack Trainee",
    company: "NIIT StackRoute",
    location:"Chennai, India",
    Type:"Full-Time",
    date: "October 2022 - October 2023",
    desc: "During my tenure at StackRoute as a Full Stack Trainee, I led the development of impactful projects, including a responsive Peer-to-Peer (P2P) Lending Platform, user-centric E-commerce App (Go Cart), a Music App (Spotify Clone). Additionally, I crafted a Java Jukebox, showcasing my proficiency in Java, SQL, and JDBC. Through these projects, I gained extensive experience in frontend, backend, testing, DevOps, and databases, solidifying my capabilities in software development. StackRoute significantly contributed to my growth in the tech industry.",
    skills: [
      "Java",
      "HTML",
      "CSS",
      "JavaScript",
      "MySQL",
      "MongoDB",
      "PostgreSQL",
      "Firebase",
      "Angular",
      "ReactJs",
      "Node.js",
      "Bootstrap",
      "SpringBoot",
      "MicroServices",
      "Git",
      "AWS",
      "CI/CD",
      "Docker",
      "Heroku",
      "RestApi",
      "Maven",
      "Junit",
      "Mockito",
      "VS Code",
      "RabbitMQ",
      "Postman",
      "Canva",
      "Figma",
      "Vercel",
      "Netlify"
    ]
    
    
  },

  {
    id: 1,
    img: drim,
    role: "Influencer Marketing Manager",
    company: "DRIM Global",
    location:"Remote",
    Type:"Freelance",
    date: "October 2023 - November 2023",
    desc: "As an Influencer Marketing Manager at Drim Global, I gained valuable insights into recruiting and onboarding influencers, fostering collaborations, and driving successful marketing campaigns. Connecting influencers with Drim allowed me to learn new things and develop interests in influencer outreach, negotiation, and strategic collaboration, enhancing my expertise in digital marketing strategy and influencer relationship management.",
    skills: [
      "Influencer Outreach and Relationship Management",
      "Marketing Campaign Strategy",
      "Collaboration Facilitation",
      "Negotiation",
      "Digital Marketing Strategy",
      "Customer Acquisition",
      "Social Media Management",
      "Influencer Marketing Analytics",
      "Content Development for Influencer Partnerships",
      "Campaign Performance Analysis and Optimization"
    ]
    
  },
  {
    id: 2,
    img: aws1,
    role: "QA Analyst",
    company: "Amazon Web Services",
    Type:"Full-Time",
    location:"Chennai, India",
    date: "November 2021 - November 2022",
    desc: "Collected accurate ground truth data for product development following precise instructions. Calculated and reported results with precision. Exhibited a strong grasp of procedures and guidelines for new tasks/releases. Demonstrated adeptness in using software tools for data capture and adhered to organizational processes rigorously. Consistently achieved daily targets while managing internal and external dependencies.",
    skills: [
      "AWS Cloud Computing", "SQL (Structured Query Language)", "MTurk (Amazon Mechanical Turk)", "SMGT (Salesforce Management)", "Data Analysis", "Project Management", "Cloud Security", "Python Programming", "Linux Administration", "Data Visualization"
    ],
  },

  {
    id: 3,
    img: pantech,
    role: "Hardware Engineer Intern",
    company: "Pantech Solutions",
    Type:"Internship",
    location:"Chennai, India",
    date: "December 2020 - January 2021",
    desc: "Studied the fundamentals of Arduino architecure,focusing on eriheral devices and their interaction. Gained proficiency in interfacing and programming wireless devices, and develop a deep understanding of microcontroller functions and their various other devices.",
    skills: [
      "Hardware Design and Development", "Circuit Design and Analysis", "Embedded Systems Programming", "PCB Design", "Troubleshooting and Problem-Solving", "Testing and Quality Assurance", "Documentation Skills", "Collaboration and Communication", "Project Management", "Arduino", "Raspberry Pi"
    ],
  },

  
  
];

export const education = [
  {
    id: 0,
    img: niit1,
    school: "National Institute of Information Technology",
    date: "Oct 2022 - Oct 2023",
    studyType: "Full-time",
    grade: "A",
    desc: "Engaged in a comprehensive Full Stack Product Engineering program, I accomplished various end-to-end projects, elevating my expertise in frontend, backend, database management, and DevOps. Notable projects include a P2P application, Music application, a Java Jukebox utilizing JDBC and SQL, and an E-commerce application. These experiences have significantly contributed to my skills in diverse aspects of my Tech journey.",
    degree: "Post Graduate Program in Full Stack Product Engineering",
  },
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/4/49/Anna_University_Logo.svg",
    school: "Anna University, Chennai",
    date: "July 2017 - Sep 2021",
    studyType: "Full-time",
    grade: "7.5 CGPA",
    desc: "Holding a degree in Electronics and Communication Engineering, I have honed my skills in various aspects of Electronics and Communication, specializing in C and Python programming. During my academic tenure, I successfully completed projects, particularly in Brain-Controlled Robotic Car and Wireless Power Transmission, where I utilized MATLAB and Arduino for implementation.",
    degree: "Bachelor of Engineering - B.E. in Electronics and Communication Engineering",
  },
  {
    id: 1,
    img: dav,
    school: "DAV Hr Sec School, Chennai",
    date: "June 2015 - Apr 2017",
    studyType: "Full-time",
    grade: "82%",
    desc: "I accomplished my high school education, encompassing both Class 11 and Class 12, at DAV Hr Sec School in Chennai, where my focus of study was the Computer Science Group along with Physics, Chemistry, and Mathematics.",
    degree: "Class 12" ,
  },
  {
    id: 2,
    img: gill,
    school: "Gill Adarsh Mat Hr Sec School, Chennai",
    date: "Apr 2014 - Apr 2015",
    studyType: "Full-time",
    grade: "90%",
    desc: "I completed my class 10 education at Gill Adarsh Mat Hr Sec School, Chennai.",
    degree: "Class 10",
  },
];

export const projects = [
  {
    id: 1,
    title: "E-commerce Application",
   
    description:
      "GoCart is a comprehensive e-commerce platform designed to streamline online business management and enhance customer experience. It provides a user-friendly interface for buyers, integrating essential features such as secure payment gateways, product management, and customer support. GoCart also incorporates advanced functionalities like SMTP for efficient communication, password recovery for users, and the option to easily delete accounts.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2Fecom1.png?alt=media&token=0e200b65-9d4c-40bc-a842-a5d703e91796",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2FScreenshot%202023-10-18%20093625.png?alt=media&token=fbfc45b8-bfe2-4f43-8650-cba6b3568c9c",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2FScreenshot%202023-10-18%20093651.png?alt=media&token=57005aa7-0669-4263-b70d-49f1a562d60d",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2FScreenshot%202023-10-18%20093702.png?alt=media&token=6a4d0c2f-ffa6-4a06-9098-9cc5529a2ad5",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2FScreenshot%202023-10-18%20093715.png?alt=media&token=d01da682-7018-4895-bcc6-60cf7ebc4186",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/ecommerce%2FScreenshot%202023-10-18%20093754.png?alt=media&token=a5bc0e04-fff9-4b19-8a67-6828ac86c30e",

    tags: [
      "SpringBoot",
      "Angular",
      "Angular Material",
      "AWS",
      "Java",
      "SMTP",
      "Typescript",
      "Junit",
      "EmailJS",      
      "CI/CD",
      "SQL",
      "JWT",
      "Websocket",
      "Git",
      "Github",
      "HTML",
    "CSS",
    ],
    category: "web app",
    github: "",
  
  },
  {
    id: 2,
    title: "Lending Lane P2P",
   
    description:
      "P2P stands for Peer-to-Peer. It is a decentralized communications model where each party has the same capabilities and either party can initiate a communication session. In a P2P network, each computer can act both as a client and a server, allowing for shared access to files and peripherals without the need for a central server. This means that each computer on the network can share and access resources directly with every other computer, allowing for more efficient and direct sharing of information and files.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2Flendinglane.png?alt=media&token=c6d516d8-ee25-4314-b8a0-1cb043296307",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-10-18%20094200.png?alt=media&token=3c07c4cc-df6c-4dd6-b017-13d4b7141f11",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-10-18%20094147.png?alt=media&token=6739ce1e-1f65-4db4-8774-6e4fe1e4ca78",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20132750.png?alt=media&token=c1a41b18-df43-45d2-90e3-e4502f770417",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20133703.png?alt=media&token=0784d650-ab32-4e4c-a751-585ca4a75c51",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20133922.png?alt=media&token=def7fe3a-cdd3-443e-a833-56db1262398b",
      image7:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20134145.png?alt=media&token=8beb4c88-6bc5-4f98-9f3e-d68df43fd179",
      image8:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20134357.png?alt=media&token=6cc14513-a420-44bb-a5f4-0d04b5ae2def",
      image9:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20134423.png?alt=media&token=2c0294d7-c22d-4a99-bc21-81fcf34622c4",
      image10:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/P2P%2FScreenshot%202023-12-02%20134446.png?alt=media&token=d888ee93-564b-4f70-bd13-6fd4db395192",
     
    tags: [
      "SpringBoot",
      "Angular",
      "Material UI",
      "Github",
      "AWS",
     
      "SMTP",
      "Mockito",
      "CI/CD",
      "SQL",
      "JWT",

      "HTML/CSS",
      "RabbitMQ",
      "Docker",
      "Websocket",
      "Neo4J",
      "MongoDB",
      "Junit",
      "Git"
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/P2PLending",
  
  },
  {
    id: 3,
    title: "Blog Hub",
   
    description:
      "BlogHub is an interactive blogging website, developed by me, that provides a creative space for users to share their thoughts and ideas through engaging blog posts. Join BlogHub's growing community to showcase your writing skills and connect with like-minded individuals. Start your blogging journey today with BlogHub!",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Images%2Fbloghub.png?alt=media&token=c60673ff-9278-46f4-bfae-a2b288c45e43",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Images%2Fbloghub1.png?alt=media&token=98d837f2-782f-4707-b318-71e5ec552dbe",
    

    tags: [
      
      "Angular",
      "Typescript",
      "Angular Material",
      "Github",
      "CSS",
      "HTML",
      "JSON",
      "Git"
    ],
    category:"frontend",
    github: "https://github.com/naveenkumarans/bloghub",
  
  },

  {
    id: 4,
    title: "Keep Notes",
   
    description:
      "KeepNotes is a user-friendly note-taking application that enables individuals to organize and manage their thoughts, ideas, and important information effortlessly. With a simple and intuitive interface, KeepNotes allows users to create, edit, and categorize their notes efficiently. Whether you're a student, professional, or a busy individual, KeepNotes is your go-to solution for staying organized and productive.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2FKeep-Note-newly-added-note-in-card.png?alt=media&token=36b72870-0d67-4681-817f-0e278a56f9b5",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2FKeep-Note.png?alt=media&token=4b4d3f22-7cbc-4d39-95d1-10ef6d4b200b",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2Fkeep%20notes.png?alt=media&token=bbbbdf6c-3f93-437a-83c5-eae1e2ddd4ec",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2Fkeep-note-expected-output.jpg?alt=media&token=dce25d08-6172-47b8-b898-b35be9f9e8fb",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2Fkeepnote.png?alt=media&token=ccb5e4e4-5d78-4fdc-a5ea-8eca049e45d0",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotes%2Fkeepnote2.png?alt=media&token=7683e9a0-3956-4aa9-a3aa-cf9464deaf71",

    tags: [
      "Angular",
      "Typescript",
      "Angular Material",
      "Github",
      "HTML",
      "CSS",     
      "CI/CD",
      "SQL",
      "Git",
      "JSON",
      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/KeepNotes",
  
  },

  {
    id: 5,
    title: "KeepNotes using JS",
   
    description:
      "Keep Notes is an intuitive note-taking Javascript based application that helps users effortlessly organize and manage their ideas, thoughts, and crucial information. Built with HTML, CSS, and JavaScript, it offers a straightforward and user-friendly interface.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/keepnotesjs%2Fkeepnotesjs.png?alt=media&token=d38ff3ce-d97b-41f3-a92f-dfe69cbcdf26",
     

    tags: [
    "JavaScript",
      "Git",
      "Github",
      "HTML",
      "CSS",
      "JSON"
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/KeepNotes-using-Javascript",
  
  },

  {
    id: 6,
    title: "SHOWTIME",
   
    description:(
    <p>
      "Showtime is a visually engaging Netflix clone built using HTML, CSS, and Angular, delivering a seamless user interface for browsing and streaming movies and TV shows. With a focus on front-end development, Showtime offers a user-friendly design that allows easy navigation and exploration of various titles. Whether you're a movie enthusiast or simply looking for an immersive streaming experience, Showtime offers an attractive UI that brings the world of entertainment to your fingertips. Please {' '} 
      <a
          href="https://cinesync.netlify.app/"
          style={{
      
            textDecoration: 'none',
            width: '70px',
           position: 'relative',
           top: '3px',
            textAlign: 'center',
            padding: '3px 13px',
            color: '#ffffff',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '600',
            transition: 'all 0.2s ease-in-out !important',
            background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
            
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          ClickHere
        </a>
        <span style={{ marginRight: '8px' }}></span>
        to explore the live project .
        
      </p>
    ),
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132143.png?alt=media&token=9365579d-876e-4e1e-8ff1-e77fb8d37e1f",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132232.png?alt=media&token=782977cb-4709-463d-ae9f-bf8118076e83",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132244.png?alt=media&token=c2deee17-c839-428a-86fa-df9cd6c797a7",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132256.png?alt=media&token=e973de8e-3063-4943-916b-d02041039826",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-10-17%20160729.png?alt=media&token=d6d6410b-0ad3-47c9-8dd0-2d340db24160",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-10-17%20160714.png?alt=media&token=92f93fde-10b2-40c4-a572-2fdec359d50a",
      image7:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132316.png?alt=media&token=380327ea-a51d-46a9-bdc3-a67a91b36c27",
      image8:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/netflix%2FScreenshot%202023-12-06%20132344.png?alt=media&token=5509cfa0-988a-493b-9f61-4b5c640d3f2c",
      
    tags: [
     
      "Angular",
      "Typescript",
      "Angular Material",
      "Github",
      "Git",
    "HTML",
    "CSS",
      "JSON",
      "Netlify",
      "Firebase",
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/netflixclone",
  
  },

  {
    id: 7,
    title: "Wat A Pizza",
   
    description:
      "Wat A Pizza is a user-friendly pizza ordering web application that lets users customize and order their favorite pizzas effortlessly. Created with HTML, CSS, and JavaScript, Wat A Pizza offers a simple yet engaging interface, allowing customers to select their desired toppings, crust preferences, and sizes before placing their orders. Whether it's a classic Margherita or a personalized specialty pizza, Wat A Pizza ensures a smooth and enjoyable ordering experience directly from the web browser.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/pizzordering%2Fpizzaordering2.png?alt=media&token=269ca806-7ab9-48a8-8e3f-4aa2b8ca3215",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/pizzordering%2Fpizzaordering1.png?alt=media&token=808e3e29-8146-4d7a-b590-62071a315592",

    tags: [
     
      
      "JavaScript",
      
      "Github",  
      "Git",   
      "JSON",
      "HTML",
      "CSS",
      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/Watapizza",
  
  },

  {
    id: 8,
    title: "Music Application",
   
    description:
      "Spotify is a dynamic music streaming application that brings the world of music to your fingertips. With a sleek and user-friendly interface, Spotify allows users to explore and enjoy a vast collection of songs and playlists. Leveraging the power of Angular and SpringBoot Spotify offers seamless music playback and personalized recommendations, catering to diverse musical tastes and preferences.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/spotify%2Fspotify.png?alt=media&token=8922583e-5bad-4a4d-9dd2-2aa5c6f55fc8",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/spotify%2FScreenshot%202023-10-18%20100100.png?alt=media&token=14ca55c4-de33-4882-84d5-2552528e3a61",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/spotify%2FScreenshot%202023-10-18%20100136.png?alt=media&token=9a28d2bd-7c5a-4a32-abf5-b505e2b67f18",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/spotify%2FScreenshot%202023-10-18%20100918.png?alt=media&token=98ad8209-3841-47bc-816d-7087700b4331",
    

    tags: [
      "SpringBoot",
      "Angular",
      "Typescript",
      "Angular Material",
      "Github",
      "Git",
      "AWS",
      "Java",
      "Junit",    
      "SQL",
      "JWT",
      "JSON",
      "HTML",
      "CSS",
      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/SpotifyClone",
  
  },

  {
    id: 9,
    title: "Guided Tours",
   
    description:
      "Day Tours is a user-friendly tour application that provides an array of exciting local day tours and experiences. With an intuitive interface and seamless functionality, Day Tours allows users to easily explore and book diverse day trip options. Whether you're interested in adventurous escapades or cultural explorations, Day Tours offers a convenient platform to plan and enjoy memorable day trips, making your travel experiences seamless and enriching.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/tours%2Fguided-tours.png?alt=media&token=9bcafd58-bce8-4d97-8206-0130b014df9d",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/tours%2Fguided%20tours1.png?alt=media&token=ce8f7594-0b77-4cb7-953b-30393a08f4e1",
    

    tags: [
      "Angular",
      "Typescript",
      "Angular Material",
      "Github",
      "Git",
      "Javascript",
      "JSON",
      "HTML",
      "CSS",
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/GuidedTours",
  
  },
  {
    id: 10,
    title: "JukeBox Java Project",
   
    description:
      "JukeBox is a user-friendly music application developed in Java, incorporating JDBC and SQL with a robust backend powered by JDBC and SQL, JukeBox enables smooth navigation and organization of tracks, playlists, and albums. Whether you're a music enthusiast or simply looking for a convenient music management solution, JukeBox offers an intuitive platform to curate and enjoy your music library.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/jukebox%2Fjukebox.png?alt=media&token=52924b59-7cd5-4aba-a79d-9749bc832304",

    tags: [
      "Java",
      "Junit",
      "JDBC",      
      "SQL",
   
      
    ],
    category: "java",
    github: "https://github.com/naveenkumarans/JukeBox-Project",
  
  },
  {
    id: 11,
    title: "WhatsApp Chat Starter using Angular",
   
    description:
      "WhatsApp Chat Starter is a convenient web application built using HTML, CSS, TypeScript, Git, Json, Firebase and Angular. With its user-friendly interface, it enables users to initiate a WhatsApp conversation without the need to save the contact. By seamlessly integrating with the WhatsApp API, this application provides a hassle-free experience for users who wish to communicate instantly without the burden of saving new contacts. Its intuitive design and efficient functionality make it a go-to solution for quick and direct communication, catering to the modern need for instant connectivity."
      ,
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/whatsappmessager%2F22.png?alt=media&token=3e7449f0-dd9c-407e-96d0-63f62e657000",

    tags: [
      "Angular", 
      "Angular Material",
      "HTML",
      "CSS",
     "Typescript",
      "Bootstrap",      
      "Git",
      "Firebase",
      "Javascript",
      "JSON",
      "Github",
      "Netlify",
   
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/WhatsApp-Chat-Initiater-using-Angular",
  
  },


  {
    id: 12,
    title: "WhatsApp Chat Starter using ReactJS",
   
    description: (
      <p>
          Experience the ease of initiating conversations without the hassle of saving contacts. I have developed this project using ReactJS, JSON, and powered by the reliability of Git, GitHub, and Firebase, offering a seamless and efficient & quick communication solution. Enjoy hassle-free chats without the need to save contacts. Please {' '}
          <a
              href="https://chatstart.netlify.app/"
              style={{
          
                textDecoration: 'none',
                width: '70px',
               position: 'relative',
               top: '3px',
                textAlign: 'center',
                padding: '3px 13px',
                color: '#ffffff',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '17px',
                fontWeight: '600',
                transition: 'all 0.2s ease-in-out !important',
                background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
                
                
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              ClickHere
            </a>
            <span style={{ marginRight: '8px' }}></span>
            to explore the live project .
            
          </p>
  ), 
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/whatsappmessager%2FScreenshot%202023-10-24%20134829.png?alt=media&token=7099796c-bd74-4b87-8bdf-a4e9e23d4313",

    tags: [
      "ReactJS", 
      "Material UI", 
      "HTML",
      "CSS",    
      "Git",
      "Firebase",
      "Github",
      "JSON",
      "Netlify",
   
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/WhatsApp-Chat-Initiater-using-React",
  
  },

  {
    id: 13,
    title: "Contact Form using ReactJS",
    description: (
      <p>
        Connect with me easily using this contact form built with React. Powered by EmailJS, it ensures a quick and reliable way to get in touch. Feel free to drop me a message or inquiry. Please{' '}
        <a
          href="https://contactnaveen.netlify.app/"
          style={{
          
            textDecoration: 'none',
            width: '70px',
           position: 'relative',
           top: '3px',
            textAlign: 'center',
            padding: '3px 13px',
            color: '#ffffff',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '600',
            transition: 'all 0.2s ease-in-out !important',
            background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
            
            
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          ClickHere
        </a>
        <span style={{ marginRight: '8px' }}></span>
        to explore the live project .
        
      </p>
    ),
    
    
    
    
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/contactform%2F2810.png?alt=media&token=2d30aaf7-0482-4630-8238-d970b43dba5b",

    tags: [
      "ReactJS", 
      "Material UI", 
      "HTML",
      "CSS",    
      "Git",
      "Github",
      "EmailJS",
      "Netlify",
      "Firebase",
   
      
    ],
    category: "frontend",
    github: "https://github.com/naveenkumarans/Contact-Form",
  
  },

  {
    id: 14,
    title: "Log Application",
   
    description:
      "I developed a robust log application, featuring a user-friendly query interface with React for the frontend, Spring Boot for the backend, and SQL for data storage. Users can seamlessly add, view, and search logs with filters such as level, message, resourceId, timestamp, traceId, spanId, commit, and metadata.parentResourceId. The application ensures efficient search results, and bonus features include search within date ranges, regular expression support, combining multiple filters, real-time log ingestion etc.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201126.png?alt=media&token=c065f431-031a-494d-aa1f-014ffc50b774",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201137.png?alt=media&token=d02abf99-10e9-40cb-a4ec-5347ebb5aab5",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201212.png?alt=media&token=69699623-8d8e-4566-9f2a-0bb58d60edb5",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201222.png?alt=media&token=076e2762-4eae-4025-bcfe-e4c6139ae706",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201232.png?alt=media&token=198aaf46-bf6e-463e-8fb9-7de6fa3380c9",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/LogApplication%2FScreenshot%202023-11-19%20201051.png?alt=media&token=985cbe97-f3eb-4348-89c7-90175a1af688",
    

    tags: [
      "SpringBoot",
      "React JS",
      "Material UI",
      "MySQL",
      "Github",
      "Git",
      "Netlify",
      "Java",
      "JSON",
      "HTML",
      "CSS",
      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/LogApplication",
  
  },


  {
    id: 15,
    title: "User Management App",
   
    description:(
      <p>
    Discover my User Management Application, built with Spring Boot and React JS. This platform provides secure user registration, login, and profile management, leveraging MongoDB for efficient data storage. The application employs JWT for authentication, creating a secure and user-friendly environment. HTML and CSS contribute to a clean and functional interface. Explore the capabilities where modern technology meets effective user management. Please{' '} 
        <a
          href="https://userify.web.app"
          style={{
          
            textDecoration: 'none',
            width: '70px',
           position: 'relative',
           top: '3px',
            textAlign: 'center',
            padding: '3px 13px',
            color: '#ffffff',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '600',
            transition: 'all 0.2s ease-in-out !important',
            background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
            
            
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          ClickHere
        </a>
        <span style={{ marginRight: '8px' }}></span>
        to explore the live project .
        
      </p>
      
      
    ),
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-23%20172011.png?alt=media&token=bfa367e1-e73a-4520-8c21-921772d3ff1a",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-23%20172034.png?alt=media&token=1e7bc09d-f0ab-4471-b5da-1f6766127d62",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-23%20172237.png?alt=media&token=bf8cb7d8-9836-4ebc-adbb-9d940d029e55",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-23%20172501.png?alt=media&token=497f6fb7-fca5-4c29-a639-4e88b9b68bd1",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-26%20184943.png?alt=media&token=fd84d4ec-3ca0-419f-998e-47600896019c",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/UserDetailsApp%2FScreenshot%202023-11-23%20172531.png?alt=media&token=5b3b416a-d668-4bff-8400-f6fa30b64e2a",
    

    tags: [
      "SpringBoot",
      "React JS",
      "Material UI",
      "Github",
      "Firebase",
      "Git",
      "Netlify",
      "Java",
      "JSON",
      "HTML",
      "CSS",
      "AWS",
      "JWT",
      "Mongo DB",

      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/UserDetails",
  
  },


  {
    id: 16,
    title: "NexTalk Connect",
   
    description:(
      <p>
    Introducing NexTalk, your all-in-one conference app powered by Firebase, Zego Cloud, and Elastic UI, seamlessly integrated with Redux Toolkit. Schedule and join meetings effortlessly, enjoying attractive features to connect with friends. With Microsoft and Google sign-in options, NexTalk ensures a secure and convenient experience for all your virtual gatherings. Elevate your conferencing with NexTalk's user-friendly interface and cutting-edge technology. Please{' '} 
        <a
          href="https://nextalk.netlify.app"
          style={{
          
            textDecoration: 'none',
            width: '70px',
           position: 'relative',
           top: '3px',
            textAlign: 'center',
            padding: '3px 13px',
            color: '#ffffff',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '600',
            transition: 'all 0.2s ease-in-out !important',
            background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
            
            
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          ClickHere
        </a>
        <span style={{ marginRight: '8px' }}></span>
        to explore the live project .
        
      </p>
      
      
    ),
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164239.png?alt=media&token=d92d2a41-7b92-4362-8981-34e263913a02",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164357.png?alt=media&token=8822cbed-cf77-422e-9b94-eb90159595fd",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164420.png?alt=media&token=dfc485e7-e141-47c3-b2a3-d78f7fd4bc4f",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164431.png?alt=media&token=0e20a416-e413-42ef-86c7-a55c1ebf067e",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164442.png?alt=media&token=27daafb8-f46f-47a4-80c3-c8d741c80470",
      image6:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164514.png?alt=media&token=25c2cdb4-ddaf-4760-8f84-27c96922d1db",
      image7:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164532.png?alt=media&token=6521e02f-cfd9-4df8-b73a-9710628e6f3b",
      image8:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164601.png?alt=media&token=a85de5e8-33ff-4bef-bde1-08102d2bbff7",
      image9:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164630.png?alt=media&token=b6379753-ecf8-4642-9f18-c4796f5583c0",
      image10:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Nextalk%2FScreenshot%202023-12-08%20164656.png?alt=media&token=ee15a6d8-cfd7-43f9-bba1-921a983899d6",
    

    tags: [
      "ReduX ToolKit",
      "React JS",
      "Material UI",
      "Github",
      "Git",
      "Netlify",
      "HTML",
      "CSS",
      "Zego Cloud",
      "Elastic UI",
      "Firebase",

      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/NexTalk-Connect",
  
  },


  {
    id: 17,
    title: "Chart Visualizer",
   
    description:(
      <p>
    Introducing the Chart Visualizer, your go-to application for insightful data visualization powered by Angular, Google Charts, and Bootstrap. Seamlessly integrating with a backend built on Java, MongoDB, and Spring Boot, my application fetches and displays comprehensive data from an API, enabling you to visualize key variables such as Intensity, Likelihood, Relevance, Year, Country, Topics, Region, and City. With an attractive and user-friendly interface, the Chart Visualizer offers dynamic filtering options for end year, topics, sector, region, PEST, source, SWOT, country, and city, ensuring a customized and interactive experience. Technology stack, including MongoDB Cloud, Lombok, and Jenkins, for a robust and efficient solution to analysis needs. Please{' '} 
        <a
          href="https://chartifye.netlify.app/"
          style={{
          
            textDecoration: 'none',
            width: '70px',
           position: 'relative',
           top: '3px',
            textAlign: 'center',
            padding: '3px 13px',
            color: '#ffffff',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '600',
            transition: 'all 0.2s ease-in-out !important',
            background: 'linear-gradient(225deg, #8A2BE2, #FF007F, #FF69B4)',
            
            
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          ClickHere
        </a>
        <span style={{ marginRight: '8px' }}></span>
        to explore the live project .
        
      </p>
      
      
    ),
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Chart%20App%2FScreenshot%202024-06-12%20224234.png?alt=media&token=1b9cafb4-0869-4534-b127-0c872aa24aaf",
      image2:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Chart%20App%2FScreenshot%202024-06-12%20224315.png?alt=media&token=7d058656-b302-4586-ae53-967970195fc9",
      image3:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Chart%20App%2FScreenshot%202024-06-12%20224459.png?alt=media&token=e810aa9b-e966-418d-a222-5c7394a8908b",
      image4:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Chart%20App%2FScreenshot%202024-06-12%20224533.png?alt=media&token=1bc1b76d-97b5-42a0-a873-074bca752735",
      image5:
      "https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/Chart%20App%2FScreenshot%202024-06-12%20224552.png?alt=media&token=64ad3981-8c17-4560-b7e0-b8d0dd356796",
    
  
    tags: [
      "Java",
      "Springboot",
      "Angular",
      "Angular Material",
      "Boostrap",
      "Git",
      "Netlify",
      "HTML",
      "CSS",
      "Firebase",

      
    ],
    category: "web app",
    github: "https://github.com/naveenkumarans/ChartDB-UI",
  
  },
  
];


export const certifications = [
  {
    id: 1,
    img: ethnus,
    role: "Full Stack MERN Stack",
    company: "Ethnus Codemithra",
    desc: "Certified in Full Stack MERN Development from Ethnus Codemithra, proficient in building end-to-end web applications using MongoDB, Express, React, and Node.js.",
    skills: [
      "MongoDB", "ExpressJS", "ReactJS", "NodeJS",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-19%20171533.png?alt=media&token=53fc24ef-4b2b-4d1f-8223-eb2b57df21f6",
  },
 

  {
    id: 2,
    img: hacker ,
    role: "Javascript (Basic)",
    company: "Hacker Rank",
    desc: "HackerRank Skill Certificate in Basic JavaScript.",
    skills: [
      "Javascript",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20114140.png?alt=media&token=aba73d56-c8e4-4584-a74b-c4f339519913",
  },
  {
    id: 3,
    img: hacker,
    role: "Javascript (Intermediate)",
    company: "Hacker Rank",
    desc: "HackerRank Skill Certificate in Intermediate JavaScript.",
    skills: [
      "Javascript",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20114123.png?alt=media&token=e11e03f6-cfa0-4001-8cbf-1a8bd0e695ff",
  },
  {
    id: 4,
    img: kallada,
    role: "Instagram Marketing",
    company: "Kallada Academy",
    desc: "I have successfully completed the Instagram Marketing Certification from Kallada Academy, demonstrating proficiency in leveraging Instagram for effective marketing strategies.",
    skills: [
      "Instagram Marketing",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20111218.png?alt=media&token=0e90c6aa-df85-42fc-afdf-9ac943270566",
  },

  {
    id: 5,
    img: udemy,
    role: "Java programming for beginners",
    company: "Udemy",
    desc: "I have completed a Java Programming for Beginners course on Udemy, acquiring foundational skills in Java development and programming principles.",
    skills: [
      "Java",
    ],
    doc:"https://udemy-certificate.s3.amazonaws.com/image/UC-6dbc9f0e-125a-45fe-8108-0ad642883463.jpg",
  },
  {
    id: 6,
    img: udemy,
    role: "Javascript Ultimate Course",
    company: "Udemy",
    desc: "I have successfully completed a comprehensive JavaScript course on Udemy, acquiring knowledge of fundamental concepts and advanced techniques in modern web development.",
    skills: [
      "Javascript ",
    ],
    doc:"https://udemy-certificate.s3.amazonaws.com/image/UC-29f6531d-6265-4284-9645-91140eeed5a1.jpg",
  },
  {
    id: 7,
    img: greatlearning,
    role: "Java Programming",
    company: "Great Learning",
    desc: "I have completed a Java Programming on Great Learning, acquiring foundational skills in Java development and programming principles.",
    skills: [
      "Java",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20111123.png?alt=media&token=cb9e3891-40ad-44a6-bc8a-93466f04f5d7",
  },
  {
    id: 8,
    img: skill,
    role: "Introduction to CyberSecurity",
    company: "Skill Up",
    desc: "I have completed an introductory course on cybersecurity from Skill Up, acquiring fundamental knowledge and practical insights into the field of cybersecurity.",
    skills: [
      "Data Protection Techniques","Network Security Fundamentals","Cyber Threat Awareness,"
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20111152.png?alt=media&token=3d79133d-55d3-42d1-8f6d-747a51bdc6ed",
  },
  {
    id: 9,
    img: cursa,
    role: "Basic game in Unity by Brackeys",
    company: "Cursa",
    desc: "I have completed the fundamentals of game development in Unity with Brackeys. This course covers the basics of game development, including a basic game tutorial. I gained a solid understanding of creating interactive gameplay elements and developed a keen interest in designing captivating digital experiences.",
    Skills: [
      "Game Development Basics",
      "Unity Scripting Fundamentals",
      "Game Physics and Mechanics Understanding",
      "Unity Animation and Character Control",
      ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2Fcursa.png?alt=media&token=04c96d8f-9c04-407b-8861-482b21cdd93e",
  },
  {
    id: 10,
    img: google,
    role: "Fundamentals of Digital Marketing",
    company: "Google",
    desc: "I have completed the Fundamentals of Digital Marketing course offered by Google, gaining essential knowledge and practical insights into various aspects of digital marketing, including search engines, social media, and advertising strategies.",
    skills: [
      "Search Engine Optimization (SEO)", "Social Media Marketing", "Content Marketing", "Email Marketing", "Mobile Marketing", "Web Analytics", "Advertising Campaign Management",
    ],
    doc:"https://firebasestorage.googleapis.com/v0/b/portfolioimages-fdfbd.appspot.com/o/certificates%2FScreenshot%202023-10-20%20111137.png?alt=media&token=936d47d1-121b-4359-9cca-ff78b6a683e7",
  },
];

